import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import customer from "./modules/customer";
import packages from "./modules/packages";
import packageFeature from "./modules/packageFeature";
import rate from "./modules/rate";

let store = null;

if (process.env.VUE_APP_MODE !== "library") {
  Vue.use(Vuex);
  store = new Vuex.Store({
    state: {},
    mutations: {},
    getters: {},
    actions: {},
    modules: { auth, customer, packages, rate, packageFeature },
  });
}

export default store;
